import React from "react";
import { AuditLogTimeline, AuditLogEntry, DEFAULT_FIELD_LABELS } from "./AuditLogTimeline";

interface AuditLogSectionProps {
  title?: string;
  entries: AuditLogEntry[];
  isLoading?: boolean;
  error?: string | null;
  onRetry?: () => void;
  emptyMessage?: string;
  emptyDescription?: string;
  fieldLabels?: Record<string, string>;
  fieldFormatters?: Record<string, (value: unknown) => string>;
  hasMore?: boolean;
  onLoadMore?: () => void;
  loadingMore?: boolean;
}

/**
 * Section wrapper for AuditLogTimeline with a header.
 *
 * @see docs/specifications/2026-01-18-unified-audit-logging.md
 */
export const AuditLogSection: React.FC<AuditLogSectionProps> = ({
  title = "Historia zmian",
  entries,
  isLoading,
  error,
  onRetry,
  emptyMessage,
  emptyDescription,
  fieldLabels = DEFAULT_FIELD_LABELS,
  fieldFormatters,
  hasMore,
  onLoadMore,
  loadingMore,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
      <h2 className="text-lg font-semibold text-neutral-900 mb-4">{title}</h2>

      <AuditLogTimeline
        entries={entries}
        isLoading={isLoading}
        error={error}
        onRetry={onRetry}
        emptyMessage={emptyMessage}
        emptyDescription={emptyDescription}
        fieldLabels={fieldLabels}
        fieldFormatters={fieldFormatters}
        hasMore={hasMore}
        onLoadMore={onLoadMore}
        loadingMore={loadingMore}
      />
    </div>
  );
};

export default AuditLogSection;
